import { render, staticRenderFns } from "./CadastroPrioridadeTarefa.vue?vue&type=template&id=f2bb00c0&"
import script from "./CadastroPrioridadeTarefa.vue?vue&type=script&lang=js&"
export * from "./CadastroPrioridadeTarefa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports